/**
@ngdoc directive
@name labelJaws18AttrForFix

@description
This directive fix the JAWS 18 problem which occurs when there's label element without for attribute on the page
and form control without an explicit label.<br />
This can be removed if the problem is fixed in JAWS 18 update.
*/
(function() {

    var labelJaws18AttrForFix = function($timeout) {
        return {
            restrict: "E",
            replace: false,
            transclude: false,
            link: function(scope, element, attrs){

                $timeout(function(){
                    if(!angular.isDefined(attrs['for'])){
                        var isCheckboxLabel = element.find('input[type=checkbox]').length;
                        var isRadioLabel    = element.find('input[type=radio]').length;
                        if(!isCheckboxLabel && !isRadioLabel){
                            element.attr('for','jaws18ForAttributeFix');
                        }
                    }
                });

            }
        };
    }
    labelJaws18AttrForFix.$inject = ['$timeout'];
    angular.module('app').directive('label', labelJaws18AttrForFix);

}());